export const slugMap = {
  "invoice-payment": {
    title: "Invoice Payment",
    tableDef: "",
    path: "invoicePayment1",
  },
  "bin-putaway-worksheet": { title: "Bill Putaway Worksheet", tableDef: "" },
  "bin-transfer": { title: "Bin Transfer", tableDef: "", path: "binTransfer1" },
  check: { title: "Check", tableDef: "", path: "Check" },
  commission: { title: "Commission", tableDef: "" },
  "credit-card": { title: "Credit Card", tableDef: "", path: "CardChrg" },
  "customer-deposit": {
    title: "Customer Deposit",
    tableDef: "",
    path: "customerDeposit1",
  },
  "deposit-application": {
    title: "Deposite Application",
    tableDef: "",
    path: "depositApplication1",
  },
  "expense-report": { title: "Expense Report", tableDef: "", path: "ExpRept" },
  "inventory-cost-revaluation": {
    title: "Inventory Cost Revaluation",
    tableDef: "",
    path: "InvReval",
  },
  "inventory-distribution": { title: "Inventory Distribution", tableDef: "" },
  oppurtunity: { title: "Oppurtunity", tableDef: "", path: "oppurtunity1" },
  paycheck: { title: "Paycheck", tableDef: "" },
  "paroll-liability-check": { title: "Payroll Liability Check", tableDef: "" },
  "payroll-adjustment": { title: "Payroll Adjustment", tableDef: "" },
  "revenue-arrangement": {
    title: "Revenue Arrangement",
    tableDef: "",
    path: "RevArrng",
  },
  "revenue-commitment": { title: "Revenue Commitment", tableDef: "" },
  "revenue-commitment-reversal": {
    title: "Revenue Commitment Reversal",
    tableDef: "",
  },
  "work-order": { title: "Work Order", tableDef: "" },

  "assembly-build": { title: "Assembly Build", tableDef: "", path: "Build" },
  "statement-charge": {
    title: "Statement Charge",
    tableDef: "",
    path: "CardChrg",
  },
  "customer-refund": {
    title: "Customer Refund",
    tableDef: "",
    path: "CustRfnd",
  },
  "cash-sale": { title: "Cash Sale", tableDef: "", path: "CashSale" },
  "custom": {
    title: "AP Check Request List",
    tableDef: "",
    path: "Custom",
  },
  "credit-memo": { title: "Credit Memo", tableDef: "", path: "CustCred" },
  invoice: { title: "Invoice", tableDef: "", path: "CustInvc" },
  payment: { title: "Payment", tableDef: "", path: "CustPymt" },
  "cash-refund": { title: "Cash Refund", tableDef: "", path: "CustRfnd" },

  deposit: { title: "Deposit", tableDef: "", path: "Deposit" },
  estimate: { title: "Estimate", tableDef: "", path: "Estimate" },
  // "expense-reports": {
  //   title: "Expense Reports",
  //   tableDef: "",
  //   path: "ExpRept",
  // },
  "currency-revaluation": {
    title: "Currency Revaluation",
    tableDef: "",
    path: "FxReval",
  },

  "inventory-adjustment": {
    title: "Inventory Adjustment",
    tableDef: "",
    path: "InvAdjst",
  },
  "inventory-transfer": {
    title: "Inventory Transfer",
    tableDef: "",
    path: "InvTrnfr",
  },
  "item-receipt": { title: "Item Receipt", tableDef: "", path: "ItemRcpt" },
  "item-fulfillment": {
    title: "Item Fulfillment",
    tableDef: "",
    path: "ItemShip",
  },

  journal: { title: "Journal", tableDef: "", path: "Journal" },
  opportunity: { title: "Opportunity", tableDef: "", path: "Opprtnty" },
  "purchase-order": { title: "Purchase Order", tableDef: "", path: "PurchOrd" },
  "return-authorization": {
    title: "Return Authorization",
    tableDef: "",
    path: "RtnAuth",
  },

  // "sales-order": { title: "Sales Order", tableDef: "", path: "SalesOrd" },
  "sales-tax-payment": {
    title: "Sales Tax Payment",
    tableDef: "",
    path: "TaxPymt",
  },
  transfer: { title: "Transfer", tableDef: "", path: "Transfer" },
  "transfer-order": { title: "Transfer Order", tableDef: "", path: "TrnfrOrd" },

  "assembly-unbuild": {
    title: "Assembly Unbuild",
    tableDef: "",
    path: "Unbuild",
  },
  "vendor-return-authorization": {
    title: "Vendor Return Authorization",
    tableDef: "",
    path: "VendAuth",
  },
  "credit-card-refund": { title: "Credit Card Refund", tableDef: "", path: "CardRfnd" },
  "vendor-bill-list": { title: "Vendor Bill List", tableDef: "", path: "VendBill" },
  "bill-credit-list": { title: "Bill Credit List", tableDef: "", path: "VendCred" },
  "bill-payment-list": { title: "Bill Payment List", tableDef: "", path: "VendPymt" },
};

export function createSlug(title = "") {
  return title.trim().toLowerCase().replace(/\s+/g, "-");
}
